export enum CoversExclusionTabs {
  WhatsIncluded,
  WhatsExcluded,
}
